import config from '../util/config';

const useIsDevTargetEnv = (): boolean => {
  return config.lifeomicTargetEnvironment === 'lifeomic-dev';
};

export default useIsDevTargetEnv;
